import React from "react";
import styled from "styled-components";

export default styled.select`
    font-size: 20px;
    line-height: 24px;
    // color: #515151;
    width: 366px;
    height: 58px;
    text-align: center;
    display: block;
    margin: 0 auto 20px;
    border: 1px solid #979797;
    box-sizing: border-box;
    
    color: #757575;
    padding: 15px;
width: 100%;
height: 40px;
padding: 10px;
font-size: 14px;
margin-top: 10px;
    text-align: left;
`;
